<template>
  <v-form ref="form_2" v-model="formValid" lazy-validation>
    <v-container>
      <v-layout column justify-space-between>
        <v-flex xs12 class="ma-0 pa-0 bump_up">
          <FlightSearchDescription :descriptions="descriptions" />
        </v-flex>
        <v-flex xs12>
          <v-container>
            <v-layout row wrap align-center>
              <v-flex xs12 sm6 class="pt-4 pl-4 pb-2">
                <h1>Departing Flight</h1>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink v-if="departFlight !== null">
                <CountdownTimer />
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <div v-if="showForm === true || departFlight === null">
        <v-layout row wrap class="pb-2">
          <v-flex xs12 md6>
            <LocationSelect />
          </v-flex>
          <v-flex xs12 sm6 md5 lg4>
            <v-container>
              <v-layout row wrap justify-space-between>
                <v-flex xs12 sm7>
                  <div v-if="minMode === true">
                    <DateSelect />
                  </div>
                  <div v-else>
                    <DepartureDateSelect />
                  </div>
                </v-flex>
                <v-flex xs12 sm5>
                  <PassengerSelect />
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </v-container>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>

      <v-layout row>
        <LowestFares></LowestFares>
      </v-layout>

      <FlightSearchLoader search-type="departing" />

      <ShowErrors />

      <v-layout row xs12 class="py-2" align-content-center>
        <v-spacer></v-spacer>
        <v-flex shrink class="mt-1" v-if="minMode !== true">
          <v-radio-group row v-model="round_trip"  @change="setReturn()">
            <v-radio label="ONE-WAY" :value="false"></v-radio>
            <v-radio label="ROUND TRIP" :value="true"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex shrink class="justify-center">
          <v-btn
            @click="setNextStepQuery('return')"
            :disabled="!testCompleteStep('departing')"
            color="primary"
          >
            Continue
            <v-icon>arrow_right_alt</v-icon>
          </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-layout row xs12 class="search_pad" v-if="loading === true">
        &nbsp;
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import Vue from "vue";
import store from "../../store";
import Shared from "@/mixins/Shared";
import BookingFormMixin from "@/mixins/BookingFormMixin";
import FlightSearchLoader from "@/components/forms/sections/FlightSearchLoader.vue";
import FlightSearchDescription from "@/components/forms/FlightSearchDescription.vue";
import LowestFares from "@/components/LowestFares.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";
import ShowErrors from "@/components/pages/ShowErrors.vue";

export default {
  name: "FormDeparting",
  store: store,
  computed: {
    descriptions() {
      return this.getAllFlightDescriptions();
    }
  },
  mixins: [BookingFormMixin, Shared],
  components: {
    FlightSearchDescription,
    FlightSearchLoader,
    LowestFares,
    ShowErrors,
    CountdownTimer
  },
  data() {
    return {
      formValid: false
    };
  },
  mounted() {
    if (
      this.testCompleteStep(0) === true &&
      this.departFlight !== null &&
      this.departingFlights !== null
    ) {
      return;
    }
    if (
      this.$route.params.id !== undefined &&
      this.$route.params.id > 0
    ) {
      this.getEditBookingDetails({
        bid: this.$route.params.id
      });
    }
    const step = this.getStepNumberByIndex(
      this.getStepIndex(this.$route.path)
    );
    if (step !== this.active) {
      store.commit("setActiveStep", step);
    }
    if (this.minMode === true) {
      if (
        this.departingFlights === null ||
        this.departingFlights.length === 0
      ) {
        this.showForm = true;
      } else {
        this.showForm = false;
      }
    }
    let p = this.setupURLPath("D");
    if (
      this.$route.query.start_loc !== undefined
    ) {
      this.getRouteQuery(this.$route.query);
      this.setNextStepQuery(0);
      return;
    } else if (this.$route.params.from !== undefined) {
      this.getRouteQuery(this.$route.params);
      this.setNextStepQuery(0);
      return;
    }
    if (
      this.loading !== true &&
      this.dep_loc > 0 &&
      this.dest_loc > 0
    ) {
      this.searchFlights();
    }
  }
};
</script>
